var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.000274658,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#243CBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6646 12.1101L9.93461 18.9471C8.72461 19.4331 8.73161 20.1081 9.71261 20.4091L14.2646 21.8291L24.7966 15.1841C25.2946 14.8811 25.7496 15.0441 25.3756 15.3761L16.8426 23.0771H16.8406L16.8426 23.0781L16.5286 27.7701C16.9886 27.7701 17.1916 27.5591 17.4496 27.3101L19.6606 25.1601L24.2596 28.5571C25.1076 29.0241 25.7166 28.7841 25.9276 27.7721L28.9466 13.5441C29.2556 12.3051 28.4736 11.7441 27.6646 12.1101Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram_icon.61b57d50571e0ef4e368c12b223b1a18.svg";
export { ForwardRef as ReactComponent };